export function demoToolsErrorMessage(statusCode: number | null, serverMessage: string, fallback: string): string {
    switch (statusCode) {
        case 401:
        case 403:
            return "Staff access is required to use demo tools.";
        case 404:
            return "This no longer exists.";
        case 409:
        case 410:
            return serverMessage || "This can no longer be filled.";
        case 429:
            return serverMessage || "A synthetic fill was queued recently. Please wait before trying again.";
        case 503:
            return "Demo tools are temporarily unavailable. Please try again shortly.";
        default:
            return serverMessage || fallback;
    }
}
